import React, { useMemo } from "react"
import { baseUrlImg } from "../../config/api"

function formatDate(dateString) {
  if (!dateString) return "-"

  const date = new Date(dateString)

  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

const AircashTicket = ({ arr }) => {
  const receiptData = useMemo(() => {
    try {
      return arr.receipt ? JSON.parse(arr.receipt) : {}
    } catch {
      return {}
    }
  }, [arr.receipt])

  const receiptHtml = useMemo(() => {
    if (!receiptData.content) return null

    try {
      return atob(receiptData.content)
    } catch {
      return null
    }
  }, [receiptData])

  const aircashCode =
    receiptData.barCode ??
    receiptData.code ??
    receiptData.couponCode ??
    "-"

  const amount =
    receiptData.amount ??
    receiptData.value ??
    "-"

  const partnerTransactionId =
    receiptData.partnerTransactionID ??
    receiptData.partnerTransactionId

  if (receiptHtml) {
    return (
      <iframe
        title="Aircash Abon Receipt"
        srcDoc={receiptHtml}
        style={{
          width: "100%",
          minHeight: "800px",
          border: "none",
          background: "#fff",
        }}
      />
    )
  }

  return (
    <div>
      <div className="json_spedizionepro">
        <div
          className="d-flex justify-content-center mb-4"
          style={{ border: "unset" }}
        >
          <img
            src={`${baseUrlImg}/${arr.logo}`}
            alt="service logo"
            height={50}
          />
        </div>

        <div style={{ paddingTop: 10 }}>
          Date: <span>{formatDate(arr.created_at)}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Code: <span>{aircashCode}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Amount: <span>{amount} €</span>
        </div>

        {receiptData.serialNumber && (
          <div style={{ paddingTop: 10 }}>
            Serial Number: <span>{receiptData.serialNumber}</span>
          </div>
        )}

        {receiptData.aircashTransactionID && (
          <div style={{ paddingTop: 10 }}>
            Aircash TX ID: <span>{receiptData.aircashTransactionID}</span>
          </div>
        )}

        {partnerTransactionId && (
          <div style={{ paddingTop: 10 }}>
            Partner TX ID: <span>{partnerTransactionId}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default AircashTicket